import React from 'react'
import * as PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import styled, { injectGlobal } from 'styled-components'
import Header from '../components/header'
import Footer from '../components/footer'
import i18n from '../components/i18n'

const propTypes = {
  data: PropTypes.object.isRequired,
}

injectGlobal`
  html {
    height: 100%;
  }

  body, body>div {
    height: 100%;
    background-color: #fff;
  }

  body {
    font-family: -apple-system, Roboto, "Segoe UI", "Helvetica Neue", Helvetica, sans-serif;
    line-height: 1.5;
    margin: 0;
    -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
  }

  * { box-sizing: border-box }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  img {
    margin: 0;
  }

  a {
    color: #06367C;
  }
`

const Page = styled.div`
  position: relative;
  display: flex;
  min-height: 100%;
`

const Content = styled.div`
  min-height: 100vh;
  flex: auto;
  background-color: rgba(182,182,182,.125);
`

class TemplateWrapper extends React.Component {
  render() {
    const path = this.props.location.pathname
    const links = this.props.data.links.edges

    const languages = ['fi', 'en', 'sv']

    if (!(languages.indexOf(i18n.language) >= 0))
      i18n.changeLanguage('fi')

    return (
      <div>
        <Helmet
          title="Itsenäisen Suomen poliisi"
          meta={[
            { name: 'description', content: 'Itsenäisen Suomen poliisi' },
            { name: 'keywords', content: 'poliisimuseo, poliisi, verkkonäyttely, itsenäisen suomen poliisi' },
          ]}
        />
        <Content>
          <Header pages={links} path={path} language={i18n.language} />
          {this.props.children()}
        </Content>
        <Footer />
      </div>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper

export const query = graphql`
  query LayoutQuery {
    pages: allContentfulPage(sort: { fields: [title] }) {
      edges {
        node {
          id
          node_locale
          title
  	      slug
          subtitle
          image {
            file {
              url
            }
          }
          body {
            childMarkdownRemark {
              html
            }
          }
          featuredContent
        }
      }
    }
    links: allContentfulPage(sort: { fields: [title] }) {
      edges {
        node {
          id
          node_locale
          title
          slug
          subtitle
          featuredContent
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js